import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { ConnectionRefusedComponent } from './components/connection-refused';
import { NotFoundComponent } from './components/not-found';

const routes: Routes = [
  {
    path: 'connection-refused',
    component: ConnectionRefusedComponent,
  },
  {
    path: 'not-found',
    component: NotFoundComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ApiRoutingModule {}
